// src/components/ui/atoms/SectionTitle/SectionHeader.tsx
import React from 'react';

export interface SectionHeaderProps {
  /** if you pass children, it'll render those instead of title */
  title?: string;
  children?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, children }) => (
  <div className="">
    <div
      className="
        py-1 mb-2 px-4
        bg-gradient-to-r from-[#4B46D6] to-[#A9A6FF]
        text-white font-semibold
        flex items-center
      "
    >
      {children ?? title}
    </div>
  </div>
);

export default SectionHeader;
